import { ReactElement } from 'react';
import { EfficiencyCategory } from '../../types';
import { EnergyEfficiencyBar } from './Bar';
import { EfficiencyRow, EfficiencyRowInfoContainer } from './styles';

interface EnergyEfficiencyRowProps {
  category: EfficiencyCategory;
  disabled: boolean;
  units: number;
  percentage: number;
  onClickRow: (category: EfficiencyCategory) => void;
}

export function EnergyEfficiencyRow({
  category,
  disabled,
  percentage,
  units,
  onClickRow,
}: Readonly<EnergyEfficiencyRowProps>): ReactElement {
  function onClick(): void {
    onClickRow(category);
  }

  return (
    <tr data-testId={`efficiency-row-${category.toLowerCase()}`}>
      <td colSpan={2}>
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
        >
          <EfficiencyRow>
            <EfficiencyRowInfoContainer data-testId={`efficiency-row-info-${category.toLowerCase()}`}>
              <h4>{units}</h4>
              <span>
                {percentage}
                %
              </span>
            </EfficiencyRowInfoContainer>
            <EnergyEfficiencyBar category={category} disabled={disabled} />
          </EfficiencyRow>
        </button>
      </td>
    </tr>
  );
}
